// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Team Management — mobile-first, token-driven redesign */

.team-management {
  padding: var(--vb-space-4);
  max-width: 1200px;
  margin: 0 auto;
  min-height: 0;
  background: transparent;
  color: var(--vb-text);
  box-sizing: border-box;
}

/* ---- Header ---- */
.team-management-header .back-btn { display: none; }

.team-management.embedded {
  padding: 0;
  max-width: none;
}

.team-management.embedded .team-management-header {
  justify-content: flex-end;
}

.team-management-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--vb-space-3);
  margin-bottom: var(--vb-space-4);
}

.team-management-header h1 {
  display: flex;
  align-items: center;
  gap: var(--vb-space-2);
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  text-transform: none;
  letter-spacing: 0;
  text-align: left;
  color: var(--vb-text);
}

.back-btn,
.add-team-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--vb-space-2);
  min-height: var(--vb-tap);
  padding: 10px 16px;
  border: 1px solid transparent;
  border-radius: var(--vb-radius-sm);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--vb-transition), border-color var(--vb-transition);
}

.back-btn {
  background: var(--vb-surface);
  border-color: var(--vb-border);
  color: var(--vb-text);
}
.back-btn:hover { background: var(--vb-surface-hover); }

.add-team-btn {
  background: var(--vb-success);
  color: #fff;
}
.add-team-btn:hover { filter: brightness(0.95); }

/* ---- Add team form ---- */
.add-team-form {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: var(--vb-space-5);
  margin-bottom: var(--vb-space-5);
  box-shadow: var(--vb-shadow);
  position: relative;
  overflow: hidden;
}

.add-team-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--vb-gradient);
}

.roster-search {
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;
  margin-bottom: var(--vb-space-4);
  padding: 10px 14px;
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-sm);
  background: var(--vb-surface);
  color: var(--vb-text);
  font-size: 15px;
}

.add-team-form h3 {
  margin-top: 0;
  margin-bottom: var(--vb-space-4);
  color: var(--vb-text);
  font-size: 19px;
  font-weight: 700;
  text-align: center;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: var(--vb-space-3);
  margin-bottom: var(--vb-space-4);
}

.form-group input[type="text"] {
  flex: 1 1;
  padding: 12px 16px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  font-size: 16px;
  transition: all var(--vb-transition);
  background: var(--vb-surface-2);
  color: var(--vb-text);
  min-height: var(--vb-tap);
  box-sizing: border-box;
}

.form-group input[type="text"]:focus {
  outline: none;
  border-color: var(--vb-primary);
  box-shadow: 0 0 0 3px var(--vb-primary-soft);
}

.form-group input[type="color"] {
  width: 100%;
  height: 50px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  background: var(--vb-surface-2);
}

.form-actions {
  display: flex;
  gap: var(--vb-space-2);
}

.save-btn, .cancel-btn {
  flex: 1 1;
  min-height: var(--vb-tap);
  padding: 10px 16px;
  border: none;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: var(--vb-space-1);
  transition: all var(--vb-transition);
  justify-content: center;
}

.save-btn { background: var(--vb-primary); color: #fff; }
.save-btn:hover { background: var(--vb-primary-hover); }
.cancel-btn { background: var(--vb-surface-hover); color: var(--vb-text); }
.cancel-btn:hover { background: var(--vb-border); }

/* ---- Teams grid ---- */
.teams-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--vb-space-4);
}

/* Scoped under .team-management: .team-card is also defined in SharedMatch.css. */
.team-management .team-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  overflow: hidden;
  box-shadow: var(--vb-shadow-sm);
  transition: transform var(--vb-transition), box-shadow var(--vb-transition);
}

.team-management .team-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--vb-shadow);
}

.team-header {
  padding: var(--vb-space-4);
  border-left: 5px solid var(--vb-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--vb-space-2);
  background: var(--vb-surface-2);
}

.team-header h3 {
  margin: 0;
  color: var(--vb-text);
  font-size: 18px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
  text-align: left;
}

.team-actions,
.player-actions {
  display: flex;
  gap: var(--vb-space-2);
  flex-shrink: 0;
}

/* Scoped under .team-management: .edit-btn / .delete-btn are generic names
   defined by several components; scoping prevents cross-component overrides. */
.team-management .edit-btn,
.team-management .delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  min-width: 0;
  border: none;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  transition: filter var(--vb-transition);
}

.team-management .edit-btn { background: var(--vb-warning-soft); color: var(--vb-warning); }
.team-management .delete-btn { background: var(--vb-danger-soft); color: var(--vb-danger); }
.team-management .edit-btn:hover,
.team-management .delete-btn:hover { filter: brightness(0.9); }

.edit-team-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--vb-space-2);
  width: 100%;
}

.edit-team-form input[type="text"] {
  flex: 1 1;
  min-width: 120px;
  padding: 8px 10px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  background: var(--vb-surface-2);
  color: var(--vb-text);
}

.edit-team-form input[type="color"] {
  width: 44px;
  height: 38px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
}

.edit-actions,
.player-form-actions,
.player-edit-actions {
  display: flex;
  gap: var(--vb-space-1);
  align-items: center;
}

.save-btn-small, .cancel-btn-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  transition: filter var(--vb-transition);
}

.save-btn-small { background: var(--vb-primary); color: #fff; }
.cancel-btn-small { background: var(--vb-surface-hover); color: var(--vb-text); }
.save-btn-small:hover, .cancel-btn-small:hover { filter: brightness(0.95); }

/* ---- Players ---- */
.players-section { padding: var(--vb-space-4); }

.players-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--vb-space-2);
  margin-bottom: var(--vb-space-3);
}

.players-header h4 {
  margin: 0;
  color: var(--vb-text);
  font-size: 15px;
  font-weight: 700;
}

.add-player-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--vb-space-1);
  background: var(--vb-primary-soft);
  color: var(--vb-primary);
  border: none;
  min-height: 38px;
  padding: 6px 12px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background var(--vb-transition);
}

.add-player-btn:hover { background: var(--vb-primary); color: #fff; }

.add-player-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--vb-space-2);
  margin-bottom: var(--vb-space-3);
  padding: var(--vb-space-3);
  background: var(--vb-surface-2);
  border-radius: var(--vb-radius-sm);
  border: 1px dashed var(--vb-border-strong);
}

.add-player-form input,
.edit-player-form input {
  padding: 10px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  font-size: 15px;
  background: var(--vb-surface);
  color: var(--vb-text);
  min-height: var(--vb-tap);
  box-sizing: border-box;
}

.players-list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--vb-space-2);
}

.player-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--vb-space-2);
  padding: var(--vb-space-3);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-sm);
  background: var(--vb-surface-2);
}

.player-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--vb-space-2);
}

.player-name { font-weight: 600; color: var(--vb-text); }
.player-position { color: var(--vb-text-muted); font-size: 14px; }

.player-number {
  background: var(--vb-primary);
  color: #fff;
  padding: 2px 8px;
  border-radius: var(--vb-radius-pill);
  font-size: 12px;
  font-weight: 700;
}

.edit-btn-small, .delete-btn-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  transition: filter var(--vb-transition);
}

.edit-btn-small { background: var(--vb-warning-soft); color: var(--vb-warning); }
.delete-btn-small { background: var(--vb-danger-soft); color: var(--vb-danger); }
.edit-btn-small:hover, .delete-btn-small:hover { filter: brightness(0.9); }

.edit-player-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--vb-space-2);
  width: 100%;
}

/* ---- States ---- */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--vb-text-muted);
}

.empty-state svg { margin-bottom: var(--vb-space-4); opacity: 0.4; }

.error-message,
.success-message {
  padding: var(--vb-space-3);
  border-radius: var(--vb-radius-sm);
  margin-bottom: var(--vb-space-4);
  border: 1px solid transparent;
  font-weight: 500;
}

.error-message {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  border-color: var(--vb-danger);
}

.success-message {
  background: var(--vb-success-soft);
  color: var(--vb-success);
  border-color: var(--vb-success);
}

.loading {
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: var(--vb-text-muted);
}

/* ============================================================
   Larger screens
   ============================================================ */
@media (min-width: 640px) {
  .team-management { padding: var(--vb-space-5); }

  .team-management-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .team-management-header h1 { font-size: 28px; }

  .form-group { flex-direction: row; align-items: center; }
  .form-group input[type="color"] { width: 64px; }
  .form-actions { justify-content: flex-end; }
  .save-btn, .cancel-btn { flex: 0 0 auto; min-width: 120px; }

  .add-player-form { grid-template-columns: 2fr 1fr 1fr auto; align-items: center; }
  .edit-player-form { grid-template-columns: 2fr 1fr 1fr auto; align-items: center; }
}

@media (min-width: 1024px) {
  .teams-grid {
    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
    gap: var(--vb-space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TeamManagement.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB,oCAAoC,aAAa,EAAE;;AAEnD;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;AACvB;AACA,kBAAkB,mCAAmC,EAAE;;AAEvD;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA,sBAAsB,wBAAwB,EAAE;;AAEhD,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,oCAAoC;EACpC,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,YAAY,6BAA6B,EAAE,WAAW,EAAE;AACxD,kBAAkB,mCAAmC,EAAE;AACvD,cAAc,mCAAmC,EAAE,qBAAqB,EAAE;AAC1E,oBAAoB,4BAA4B,EAAE;;AAElD,yBAAyB;AACzB;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;+EAC+E;AAC/E;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,uCAAuC;AACzC;;AAEA,6BAA6B,kCAAkC,EAAE,wBAAwB,EAAE;AAC3F,+BAA+B,iCAAiC,EAAE,uBAAuB,EAAE;AAC3F;qCACqC,uBAAuB,EAAE;;AAE9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,uCAAuC;AACzC;;AAEA,kBAAkB,6BAA6B,EAAE,WAAW,EAAE;AAC9D,oBAAoB,mCAAmC,EAAE,qBAAqB,EAAE;AAChF,iDAAiD,wBAAwB,EAAE;;AAE3E,sBAAsB;AACtB,mBAAmB,0BAA0B,EAAE;;AAE/C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,wBAAwB,6BAA6B,EAAE,WAAW,EAAE;;AAEpE;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA,eAAe,gBAAgB,EAAE,qBAAqB,EAAE;AACxD,mBAAmB,2BAA2B,EAAE,eAAe,EAAE;;AAEjE;EACE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,uCAAuC;AACzC;;AAEA,kBAAkB,kCAAkC,EAAE,wBAAwB,EAAE;AAChF,oBAAoB,iCAAiC,EAAE,uBAAuB,EAAE;AAChF,iDAAiD,uBAAuB,EAAE;;AAE1E;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,mBAAmB,gCAAgC,EAAE,YAAY,EAAE;;AAEnE;;EAEE,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;iEAEiE;AACjE;EACE,mBAAmB,0BAA0B,EAAE;;EAE/C;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA,6BAA6B,eAAe,EAAE;;EAE9C,cAAc,mBAAmB,EAAE,mBAAmB,EAAE;EACxD,kCAAkC,WAAW,EAAE;EAC/C,gBAAgB,yBAAyB,EAAE;EAC3C,yBAAyB,cAAc,EAAE,gBAAgB,EAAE;;EAE3D,mBAAmB,uCAAuC,EAAE,mBAAmB,EAAE;EACjF,oBAAoB,uCAAuC,EAAE,mBAAmB,EAAE;AACpF;;AAEA;EACE;IACE,4DAA4D;IAC5D,sBAAsB;EACxB;AACF","sourcesContent":["/* Team Management — mobile-first, token-driven redesign */\n\n.team-management {\n  padding: var(--vb-space-4);\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: 0;\n  background: transparent;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n/* ---- Header ---- */\n.team-management-header .back-btn { display: none; }\n\n.team-management.embedded {\n  padding: 0;\n  max-width: none;\n}\n\n.team-management.embedded .team-management-header {\n  justify-content: flex-end;\n}\n\n.team-management-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--vb-space-3);\n  margin-bottom: var(--vb-space-4);\n}\n\n.team-management-header h1 {\n  display: flex;\n  align-items: center;\n  gap: var(--vb-space-2);\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  text-transform: none;\n  letter-spacing: 0;\n  text-align: left;\n  color: var(--vb-text);\n}\n\n.back-btn,\n.add-team-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--vb-space-2);\n  min-height: var(--vb-tap);\n  padding: 10px 16px;\n  border: 1px solid transparent;\n  border-radius: var(--vb-radius-sm);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background var(--vb-transition), border-color var(--vb-transition);\n}\n\n.back-btn {\n  background: var(--vb-surface);\n  border-color: var(--vb-border);\n  color: var(--vb-text);\n}\n.back-btn:hover { background: var(--vb-surface-hover); }\n\n.add-team-btn {\n  background: var(--vb-success);\n  color: #fff;\n}\n.add-team-btn:hover { filter: brightness(0.95); }\n\n/* ---- Add team form ---- */\n.add-team-form {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: var(--vb-space-5);\n  margin-bottom: var(--vb-space-5);\n  box-shadow: var(--vb-shadow);\n  position: relative;\n  overflow: hidden;\n}\n\n.add-team-form::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: var(--vb-gradient);\n}\n\n.roster-search {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 44px;\n  margin-bottom: var(--vb-space-4);\n  padding: 10px 14px;\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-sm);\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-size: 15px;\n}\n\n.add-team-form h3 {\n  margin-top: 0;\n  margin-bottom: var(--vb-space-4);\n  color: var(--vb-text);\n  font-size: 19px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--vb-space-3);\n  margin-bottom: var(--vb-space-4);\n}\n\n.form-group input[type=\"text\"] {\n  flex: 1;\n  padding: 12px 16px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  font-size: 16px;\n  transition: all var(--vb-transition);\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  min-height: var(--vb-tap);\n  box-sizing: border-box;\n}\n\n.form-group input[type=\"text\"]:focus {\n  outline: none;\n  border-color: var(--vb-primary);\n  box-shadow: 0 0 0 3px var(--vb-primary-soft);\n}\n\n.form-group input[type=\"color\"] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  background: var(--vb-surface-2);\n}\n\n.form-actions {\n  display: flex;\n  gap: var(--vb-space-2);\n}\n\n.save-btn, .cancel-btn {\n  flex: 1;\n  min-height: var(--vb-tap);\n  padding: 10px 16px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: var(--vb-space-1);\n  transition: all var(--vb-transition);\n  justify-content: center;\n}\n\n.save-btn { background: var(--vb-primary); color: #fff; }\n.save-btn:hover { background: var(--vb-primary-hover); }\n.cancel-btn { background: var(--vb-surface-hover); color: var(--vb-text); }\n.cancel-btn:hover { background: var(--vb-border); }\n\n/* ---- Teams grid ---- */\n.teams-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--vb-space-4);\n}\n\n/* Scoped under .team-management: .team-card is also defined in SharedMatch.css. */\n.team-management .team-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  overflow: hidden;\n  box-shadow: var(--vb-shadow-sm);\n  transition: transform var(--vb-transition), box-shadow var(--vb-transition);\n}\n\n.team-management .team-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--vb-shadow);\n}\n\n.team-header {\n  padding: var(--vb-space-4);\n  border-left: 5px solid var(--vb-primary);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--vb-space-2);\n  background: var(--vb-surface-2);\n}\n\n.team-header h3 {\n  margin: 0;\n  color: var(--vb-text);\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: none;\n  letter-spacing: 0;\n  text-align: left;\n}\n\n.team-actions,\n.player-actions {\n  display: flex;\n  gap: var(--vb-space-2);\n  flex-shrink: 0;\n}\n\n/* Scoped under .team-management: .edit-btn / .delete-btn are generic names\n   defined by several components; scoping prevents cross-component overrides. */\n.team-management .edit-btn,\n.team-management .delete-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  min-width: 0;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  transition: filter var(--vb-transition);\n}\n\n.team-management .edit-btn { background: var(--vb-warning-soft); color: var(--vb-warning); }\n.team-management .delete-btn { background: var(--vb-danger-soft); color: var(--vb-danger); }\n.team-management .edit-btn:hover,\n.team-management .delete-btn:hover { filter: brightness(0.9); }\n\n.edit-team-form {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--vb-space-2);\n  width: 100%;\n}\n\n.edit-team-form input[type=\"text\"] {\n  flex: 1;\n  min-width: 120px;\n  padding: 8px 10px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n}\n\n.edit-team-form input[type=\"color\"] {\n  width: 44px;\n  height: 38px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n}\n\n.edit-actions,\n.player-form-actions,\n.player-edit-actions {\n  display: flex;\n  gap: var(--vb-space-1);\n  align-items: center;\n}\n\n.save-btn-small, .cancel-btn-small {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  transition: filter var(--vb-transition);\n}\n\n.save-btn-small { background: var(--vb-primary); color: #fff; }\n.cancel-btn-small { background: var(--vb-surface-hover); color: var(--vb-text); }\n.save-btn-small:hover, .cancel-btn-small:hover { filter: brightness(0.95); }\n\n/* ---- Players ---- */\n.players-section { padding: var(--vb-space-4); }\n\n.players-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--vb-space-2);\n  margin-bottom: var(--vb-space-3);\n}\n\n.players-header h4 {\n  margin: 0;\n  color: var(--vb-text);\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.add-player-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--vb-space-1);\n  background: var(--vb-primary-soft);\n  color: var(--vb-primary);\n  border: none;\n  min-height: 38px;\n  padding: 6px 12px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background var(--vb-transition);\n}\n\n.add-player-btn:hover { background: var(--vb-primary); color: #fff; }\n\n.add-player-form {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--vb-space-2);\n  margin-bottom: var(--vb-space-3);\n  padding: var(--vb-space-3);\n  background: var(--vb-surface-2);\n  border-radius: var(--vb-radius-sm);\n  border: 1px dashed var(--vb-border-strong);\n}\n\n.add-player-form input,\n.edit-player-form input {\n  padding: 10px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  font-size: 15px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  min-height: var(--vb-tap);\n  box-sizing: border-box;\n}\n\n.players-list {\n  max-height: 260px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--vb-space-2);\n}\n\n.player-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--vb-space-2);\n  padding: var(--vb-space-3);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-sm);\n  background: var(--vb-surface-2);\n}\n\n.player-info {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--vb-space-2);\n}\n\n.player-name { font-weight: 600; color: var(--vb-text); }\n.player-position { color: var(--vb-text-muted); font-size: 14px; }\n\n.player-number {\n  background: var(--vb-primary);\n  color: #fff;\n  padding: 2px 8px;\n  border-radius: var(--vb-radius-pill);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.edit-btn-small, .delete-btn-small {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  transition: filter var(--vb-transition);\n}\n\n.edit-btn-small { background: var(--vb-warning-soft); color: var(--vb-warning); }\n.delete-btn-small { background: var(--vb-danger-soft); color: var(--vb-danger); }\n.edit-btn-small:hover, .delete-btn-small:hover { filter: brightness(0.9); }\n\n.edit-player-form {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--vb-space-2);\n  width: 100%;\n}\n\n/* ---- States ---- */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--vb-text-muted);\n}\n\n.empty-state svg { margin-bottom: var(--vb-space-4); opacity: 0.4; }\n\n.error-message,\n.success-message {\n  padding: var(--vb-space-3);\n  border-radius: var(--vb-radius-sm);\n  margin-bottom: var(--vb-space-4);\n  border: 1px solid transparent;\n  font-weight: 500;\n}\n\n.error-message {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  border-color: var(--vb-danger);\n}\n\n.success-message {\n  background: var(--vb-success-soft);\n  color: var(--vb-success);\n  border-color: var(--vb-success);\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 16px;\n  color: var(--vb-text-muted);\n}\n\n/* ============================================================\n   Larger screens\n   ============================================================ */\n@media (min-width: 640px) {\n  .team-management { padding: var(--vb-space-5); }\n\n  .team-management-header {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .team-management-header h1 { font-size: 28px; }\n\n  .form-group { flex-direction: row; align-items: center; }\n  .form-group input[type=\"color\"] { width: 64px; }\n  .form-actions { justify-content: flex-end; }\n  .save-btn, .cancel-btn { flex: 0 0 auto; min-width: 120px; }\n\n  .add-player-form { grid-template-columns: 2fr 1fr 1fr auto; align-items: center; }\n  .edit-player-form { grid-template-columns: 2fr 1fr 1fr auto; align-items: center; }\n}\n\n@media (min-width: 1024px) {\n  .teams-grid {\n    grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));\n    gap: var(--vb-space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
